import React from 'react'
import { Button } from '@chakra-ui/react'
import { FaRedoAlt } from 'react-icons/fa'
import IconWrapper from './IconWrapper'
import { RefreshButtonProps } from '../types'

const RefreshButton = ({ onRefresh, isRefreshing }: RefreshButtonProps) => (
  <Button
    rightIcon={<IconWrapper icon={FaRedoAlt} />}
    colorScheme="blue"
    variant="outline"
    onClick={onRefresh}
    isLoading={isRefreshing}
    ml={2}
  >
    Refresh
  </Button>
)

export default RefreshButton
